import { render, staticRenderFns } from "./FirstVisit.vue?vue&type=template&id=2689dc6a&scoped=true"
import script from "./FirstVisit.vue?vue&type=script&lang=js"
export * from "./FirstVisit.vue?vue&type=script&lang=js"
import style0 from "./FirstVisit.vue?vue&type=style&index=0&id=2689dc6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2689dc6a",
  null
  
)

export default component.exports